import { Injectable } from '@angular/core';
import { FooterPagesGrouped, FooterPagesResponse, FooterService, HttpHandlerService } from 'library-explorer';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  private jsonUrl = 'assets/data/data-page.json';
  private footerContentSubject = new BehaviorSubject<FooterPagesGrouped[]>([]);
  footerContent$ = this.footerContentSubject.asObservable();

  constructor(private httpWrapper: HttpHandlerService, private footerService: FooterService) { }

  getData(): Observable<any> {
    return this.httpWrapper.getThirdPartyRequest(this.jsonUrl, { withCredentials: true });
  }

  loadGroupedFooterPages() {
    this.footerService.getGroupedPages().subscribe((res: FooterPagesResponse) => {
      this.footerContentSubject.next(res.grouped);
    });
  }

  getFooterContent(): FooterPagesGrouped[] {
    return this.footerContentSubject.getValue();
  }

  updateFooterContent(content: FooterPagesGrouped[]): void {
    this.footerContentSubject.next(content);
  }
}
